<template>
  <div>
    <!-- NAV BAR -->

    <nav class="navbar navbar-expand-lg navbar-light bg-light navMovil">
      <!-- <div class="container-fluid"> -->

      <a class="navbar-brand">Forms List</a>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style="border: none;">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">

        <ul class="navbar-nav navbar-left mr-auto">
          <li class="active" >
            <a
              style="cursor:pointer;color: #555;background-color: #e7e7e7; padding: 15px; display: block;"
              @click="showRolesModal"
            >Roles</a>
          </li>
          <li class="active" >
            <a
              style="cursor:pointer;color: #555;background-color: #e7e7e7; padding: 15px; display: block;"
              @click="showModelsModal"
            >Models</a>
          </li>
        </ul>

        <ul class="nav navbar-nav navbar-logo" style="margin-right: auto !important;">
          <li>
            <img src="../assets/images/factorylogo.jpg" width="300px">
            <span
              class="small"
              style="position: absolute;bottom: 0;right:50%;top:40px"
            >
              Version {{ actualVersion }}
            </span>
          </li>
        </ul>

        <div
          class="nav navbar-nav navbar-right"
        >
          <div class="nav-item dropdown">
            <a href="#" class="nav-link dropdown-toggle" id="navbarDropdownBulk" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Columns <span class="caret"></span></a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown" style="width:200px;">
              <a
                class="dropdown-item"
                v-for="(column, columnIndex) in columns"
                :key="columnIndex"
                :style="column.hidden ? 'background-color: #e2e1e1;' : ''"
              >
                {{ column.label }}
                <i
                  v-if="column.hidden"
                  class="fas fa-eye float-right"
                  @click="column.hidden = false"
                />
                <i
                  v-else
                  class="fas fa-eye-slash float-right"
                  @click="column.hidden = true"
                />
              </a>
            </div>
          </div>

          <div
            class="nav-item"
            :style="$store.state.forms !== undefined && $store.state.forms !== null && Object.keys($store.state.forms).length > 0 ? '' : 'pointer-events:none;'">
            <a class="nav-link"
              @click="onBtnExportDataAsCsv"
              style="cursor:pointer;"
            >Export CSV</a></div>
          <div
            :style="$store.state.forms !== undefined && $store.state.forms !== null && Object.keys($store.state.forms).length > 0 ? '' : 'pointer-events:none;'"
            class="nav-item">
            <a
              class="nav-link"
              @click="showAddFormModal"
              style="cursor:pointer;"
            >Add Form</a></div>
          <div
            :style="$store.state.forms !== undefined && $store.state.forms !== null && Object.keys($store.state.forms).length > 0 ? '' : 'pointer-events:none;'"
            class="nav-item">
            <a
              class="nav-link"
              @click="logOut"
              style="cursor:pointer;"
            >Log Out</a></div>
        </div>

      </div>
    </nav>

    <!-- GRID -->

    <div id="formGrid" class="row">
      <add-form-modal ref="addModal" v-show="addFormModalVisible"></add-form-modal>
      <edit-form-modal ref="editModal" v-show="editFormModalVisible"></edit-form-modal>
      <modal-dialog></modal-dialog>

      <div
        class="heightGrid p-4"
        v-if="rows !== undefined && rows !== null"
      >
        <!-- TODO
          HIDE/SHOW COLUMNS (No close dropdown columns)
          OPEN FORM (Style cursor on row)
          FIX BUG
        -->

        <vue-good-table
          ref="forms-table"
          mode="remote"
          styleClass="vgt-table striped"
          @on-search="onSearch"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-cell-click="onCellClick"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table',
          }"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true,
            selectionText: 'Officials Models selected',
          }"
          :pagination-options="{
            enabled: true,
            perPage: 20,
            perPageDropdown: [10, 20, 30, 40, 50, 100, 200, 500, 1000, 3000],
            dropdownAllowAll: false,
            mode: 'pages'
          }"
          :rows="rows"
          :columns="columns"
          max-height="750px"
          min-height="740px"
          :fixed-header="true"
        >
          <div slot="selected-row-actions">
            <a href="#" class="dropdown-toggle" id="navbarDropdownBulk" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Bulk Actions <span class="caret"></span></a>
            <div class="dropdown-menu mr-5" style="left:-50px;width:320px;" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" @click="openModalAddJSONGitHub">Load JSON from GitHub Repository</a>
              <a class="dropdown-item" @click="openModalEnbaleDisable">Enable / Disable</a>
              <a class="dropdown-item" @click="openModalAddLibrary">Library</a>
              <a class="dropdown-item" @click="openModalAddSection">Section</a>
              <a class="dropdown-item" @click="openModalAddPracticeArea">Practice Area</a>
              <a class="dropdown-item" @click="openModalAddInternalTag">Internal Tag</a>
              <a class="dropdown-item" @click="openModalAddVersion">Version</a>
              <a class="dropdown-item" @click="openModalAddExpirationDate">Expiration Date</a>
              <a class="dropdown-item" @click="openModalAddRevisionDate">Revision Date</a>
            </div>
          </div>

            <!-- Sobrescritura de cada fila -->
            <template slot="table-row" slot-scope="props">
              <!-- Acciones -->
              <span v-if="props.column.field === 'actions'">
                <span>
                  <i
                    class="fas fa-clone"
                    style="margin-left:2px; cursor:pointer;"
                    @click="openModalDuplicateForm(props.formattedRow._id, props.formattedRow.name)"
                  />
                  <i
                    class="fas fa-trash"
                    style="margin-left:1px;cursor:pointer;"
                    @click="confirmDelete(props.formattedRow._id)"
                  />
                  <i
                    class="fas fa-edit"
                    style="cursor:pointer;"
                    @click="showEditFormModal(props.formattedRow._id)"
                  />
                </span>
              </span>

              <!-- Nombre o Título -->
              <span
                v-else-if="props.column.field === 'name' || props.column.field === 'title'"
                :style="props.formattedRow.status === 'Disabled' ? 'color: #f47373;' : ''"
              >
                <div
                  style="width:200px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                  data-toggle="tooltip"
                  data-placement="top"
                  :title="props.formattedRow[props.column.field]"
                >
                  {{
                    props.column.field === 'name'
                      ? props.formattedRow.name.length > 11
                        ? props.formattedRow.name.substr(0, 10) + '...'
                        : props.formattedRow.name
                      : props.formattedRow.title.length > 20
                      ? props.formattedRow.title.substr(0, 19) + '...'
                      : props.formattedRow.title
                  }}
                </div>
              </span>

              <!-- Iconos -->
              <span v-else-if="props.column.field === 'enableForQuestionnaire'">
                <span>
                  <div v-if="$store.state.forms.find(form => form._id === props.formattedRow._id)">
                    <i
                      style="color: #00C853; margin-top: 3px; margin-right: 3px;"
                      v-if="
                        $store.state.forms.find(form => form._id === props.formattedRow._id)
                          .enableForQuestionnaire
                      "
                      class="fas fa-check-circle pull-left"
                    ></i>
                    <i
                      style="color: gray; margin-top: 3px; margin-right: 3px;"
                      v-else
                      class="fas fa-check-circle pull-left"
                    ></i>
                  </div>
                </span>
              </span>

              <!-- Otras Columnas -->
              <span v-else :style="props.formattedRow.status === 'Disabled' ? 'color: #f47373;' : ''">
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          <div slot="emptystate">
            There are no rows
          </div>
        </vue-good-table>

      </div>

      <div style="left: 50%;position: absolute;top: 25%;" v-else>
        <f-spinner/>
        <span>Loading ...</span>
      </div>

      <notifications></notifications>
    </div>

    <!-- MODAL DUPLICATE -->

    <global-modal
      v-if="isModal === true">

      <template slot="header">

        <b>Duplicate Form</b>

      </template>

      <template slot="body">

        <p class="mb-1">Form name</p>

        <input
          type="text"
          placeholder="Type Name"
          v-model="duplicateFormName"
          class="form-control"
        >

      </template>

      <template slot="footer">

        <button
          class="btn btn-secondary"
          @click="isModal = false"
        >
          Cancel
        </button>

        <button
          :disabled="isDisableBtnClone"
          class="btn btn-success"
          @click="cloneTemplate"
        >
          Clone
        </button>

      </template>
    </global-modal>

    <!-- MODAL ROLES -->

    <global-modal
      v-if="isModalRoles === true"
      class="modalEditRoles">

      <template slot="header">

        <b>Edit Roles</b>

        <i
          class="fas fa-times float-right"
          @click="isModalRoles = false"
        ></i>

      </template>

      <template slot="body">

        <button
          class="btn btn-success float-right mt-n4"
          style="margin-bottom: 10px;"
          @click="addNewRol"
          :disabled="roles[roles.length - 1].name === '' || roles[roles.length - 1].type === '' ? true : false"
        >New</button>

        <div>
          <table class="table table-sm table-striped table-bordered table-hover table-light">
            <thead>
              <tr>
                <th class="">Name</th>
                <th class="">Type</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(role, indexRole) in roles"
                :key="indexRole"
                :id="indexRole"
              >
                <td>
                  <input
                    :id="'inputName' + indexRole"
                    class="form-control form-control-sm"
                    type="text"
                    v-model="role.name"
                    @change="prevToSaveRole(indexRole)"
                  >
                </td>

                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="role.type"
                    @change="prevToSaveRole(indexRole)"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </template>

      <template slot="footer">

        <button
          class="btn btn-secondary"
          @click="isModalRoles = false"
        >
          Cancel
        </button>

        <button
          class="btn btn-success"
          @click="saveRoles"
          :disabled="newRolesToSave.length > 0 || rolesToUpdate.length > 0 ? false : true"
        >
          Save
        </button>

      </template>
    </global-modal>

    <!-- MODAL ADD DATA BULK ACTION -->

    <global-modal
      v-if="isModalMassUpdate === true"
      class="modalEditRoles"
      :height="30">

      <template slot="header">

        <b>{{ bulkActionsModalLabel }}</b>

        <i
          class="fas fa-times float-right"
          @click="closeBulkActionsModal"
        ></i>

      </template>

      <template slot="body">

        <!-- SPINNER -->

        <div v-if="isSpinnerMassUpdate === true">
          <h5><b>{{ formsUpdated }} forms updated of {{ formsToUpdate }}</b></h5>

          <br>

          <div v-if="formsInvalidPath.length > 0">
            <h5 style="color:red;">Forms with invalid Path</h5>
            <div style="overflow-y:auto;height:300px;">
              <b><small v-for="(form, formIndex) in formsInvalidPath" :key="formIndex">{{ form.name }}<br></small></b>
            </div>
          </div>

          <!-- <f-spinner /> -->
        </div>

        <!-- CONTENT -->

        <div v-else>
          <!-- LOAD JSON FROM GITHUB -->

          <div v-if="isAddDataJSON === true">
            <input
              type="password"
              class="form-control"
              placeholder="Password"
              v-model="passwordToAddJson"
            >
            <small v-if="isInvalidPassword === true" style="color: red;">Invalid password</small>
          </div>

          <!-- ENABLE / DISABLE FORM -->

          <div v-if="isEnableDisable === true">

            <button
              class="form-control btn btn-success mb-2"
              @click="enableForms"
            >Enable</button>

            <button
              class="form-control btn btn-danger"
              @click="disableForms"
            >Disable</button>

          </div>

          <!-- INTERNAL TAG(S) -->

          <div v-if="isAddInternalTag === true">

            <search-select
              :multiple="true"
              v-model="internalTagsForForms"
              :options="tagsFormInternal"
            />
            <small style="color: red;">Press enter to assign Internal Tags</small>

          </div>

          <!-- SECTION -->

          <div v-if="isAddSection === true">

            <search-select
              v-model="sectionBulkAction"
              :options="allSections"
            />

          </div>

          <!-- LIBRARY -->

          <div v-if="isAddLibrary === true">

            <search-select
              v-model="libraryBulkAction"
              :options="$store.state.practiceAreas"
              label="name"
            />

          </div>

          <!-- PRACTICE AREA -->

          <div v-if="isAddPracticeArea === true">

            <search-select
              :taggable="true"
              :multiple="true"
              v-model="practiceAreaForForms"
              :options="practiceAreas"
            />
            <small style="color: red;">Press enter to assign Practice Area</small>

          </div>

          <!-- REVISION DATE -->

          <div v-if="isAddRevisionDate === true">

            <input
              type="text"
              id="revisionDateBulkAction"
              v-model="revisionDateBulkAction"
              v-mask="'##/##/####'"
              placeholder="MM/DD/YYYY"
              class="form-control"
            >

          </div>

          <!-- EXPIRATION DATE -->

          <div v-if="isAddExpirationDate === true">

            <input
              type="text"
              id="expirationDateBulkAction"
              v-model="expirationDateBulkAction"
              v-mask="'##/##/####'"
              placeholder="MM/DD/YYYY"
              class="form-control"
            >

          </div>

          <!-- VERSION -->

          <div v-if="isAddVersion === true">

            <input
              type="text"
              id="versionBulkAction"
              v-model="versionBulkAction"
              class="form-control"
            >

          </div>
        </div>

      </template>

      <template slot="footer">

        <button
          class="btn btn-secondary"
          @click="closeBulkActionsModal"
          :disabled="isSpinnerMassUpdate"
        >
          Cancel
        </button>

        <button
          v-if="isAddDataJSON === true"
          class="btn btn-success"
          @click="addJsonToSelectedForms"
          :disabled="passwordToAddJson !== '' && isSpinnerMassUpdate === false ? false : true"
        >
          Upload Data
        </button>

        <button
          v-else-if="labelButtonBulkAction !== ''"
          class="btn btn-success"
          @click="setBulkAction"
          :disabled="isSpinnerMassUpdate"
        >
          {{ labelButtonBulkAction }}
        </button>

      </template>
    </global-modal>

    <!--MODAL MODELS-->
    <global-modal
      v-if="isModalModels === true"
      class="modalEditModels">

      <template slot="header">

        <b>Official Models</b>

        <i
          class="fas fa-times float-right"
          @click="closeModalModels"
        ></i>

      </template>

      <template slot="body">

        <!-- <button
          class="btn btn-success float-right mt-n4"
          style="margin-bottom: 10px;"
          @click="addNewModel"
          :disabled="models[models.length - 1].name === '' || models[models.length - 1].type === '' ? true : false"
        >New</button> -->

        <vue-good-table
          ref="official-models-table"
          mode="remote"
          styleClass="vgt-table striped"
          @on-search="onSearchOModels"
          @on-page-change="onPageChangeOModels"
          @on-sort-change="onSortChangeOModels"
          @on-per-page-change="onPerPageChangeOModels"
          @on-cell-click="onCellClickOModels"
          :totalRows="totalRecordsOModels"
          :isLoading.sync="isLoading"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table Official Models',
          }"
          :pagination-options="{
            enabled: true,
            perPage: 20,
            perPageDropdown: [10, 20, 30, 40, 50, 100, 200, 500, 1000, 3000],
            dropdownAllowAll: false,
            mode: 'pages'
          }"
          :rows="rowsOModels"
          :columns="columnsOModels"
          max-height="750px"
          min-height="740px"
          :fixed-header="true">
        </vue-good-table>

        <!-- <div>
          <table class="table table-sm table-striped table-bordered table-hover table-light">
            <thead class="theadModels">
              <tr>
                <th class="tdModelNo">No</th>
                <th class="trModels">Categories</th>
                <th class="trModels">Descriptions</th>
                <th class="trModels">Fields</th>
                <th class="trModels">Field Types</th>
                <th class="trModels">Labels</th>
                <th class="trModels">Prefix</th>
                <th class="trModels">Properties</th>
                <th class="trModels">Routes</th>
                <th class="trModels">Sub Categories</th>
                <th class="trModels">Types</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(modelm, indexModel) in models"
                :key="indexModel"
                :id="indexModel"
              >
                <td class="tdModelNo">
                  <span>  {{indexModel + 1}}</span>
                </td>
                <td>
                  <input
                    :id="'inputName' + indexModel"
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.category"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.desc"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.field"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.fieldType"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.label"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.prefix"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.properties"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.route"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.subcategory"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>

                <td>
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    v-model="modelm.type"
                    @change="prevToSaveModel(indexModel)"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->

      </template>

      <template slot="footer">

        <span></span>
        <!-- <button
          class="btn btn-secondary"
          @click="isModalModels = false">
          Cancel
        </button>

        <button
          class="btn btn-success"
          @click="saveModels"
          :disabled="newModelsToSave.length > 0 || modelsToUpdate.length > 0 ? false : true">
          Save
        </button> -->

      </template>
    </global-modal>

    <create-button-model
          v-if="isAutocompleteModel === true"
          :data="autocompleteModelData"
          :model="autocompleteModel"/>
  </div>
</template>

<script>
import ModalDialog from '@/components/editor/modals/ModalDialog'
import AddFormModal from '@/components/form-grid/AddFormModal'
import EditFormModal from '@/components/form-grid/EditFormModal'
import Notifications from '@/components/editor/main/Notifications'
import GlobalModal from '@/components/editor/modals/GlobalModal.vue'
import FSpinner from '@/components/questionnaires/Spinner.vue'

import SearchSelect from '../components/searchSelect/SearchSelect.vue'
import CreateButtonModel from '../components/editor/modal-edit/CreateButtonModel.vue'

import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import { ExportToCsv } from 'export-to-csv'

export default {
  name: 'list-view',

  data () {
    return {
      moment: window.moment,

      deleteId: null,

      addFormModalVisible: false,
      editFormModalVisible: false,

      // VUE-GOOD-TABLE

      isLoading: false,
      columns: [
        {
          label: 'Q',
          field: 'enableForQuestionnaire', // Campo para el ordenamiento
          sortable: true,
          hidden: false,
          columnSlot: 'iconEnableForQuestionnaire' // Identificador del slot
        },
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Name',
            trigger: 'input'
          },
          hidden: false,
          columnSlot: 'name'
        },
        {
          label: 'Actions',
          field: 'actions',
          html: true,
          hidden: false
        },
        {
          label: 'Title',
          field: 'title',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Title',
            trigger: 'input'
          },
          hidden: false,
          columnSlot: 'title'
        },
        {
          label: 'Library',
          field: 'practiceArea',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Library',
            trigger: 'input'
          },
          hidden: false
        },
        {
          label: 'Section',
          field: 'practiceAreaSection',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Section',
            trigger: 'input'
          },
          hidden: false
        },
        {
          label: 'Practice Area',
          field: 'practiceAreaTag',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Practice Area',
            trigger: 'input'
          },
          hidden: false
        },
        {
          label: 'Internal Tags',
          field: 'internalTag',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Internal Tag',
            trigger: 'input'
          },
          hidden: false
        },
        {
          label: 'Version',
          field: 'version',
          type: 'number',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Version',
            trigger: 'input'
          },
          hidden: false
        },
        {
          label: 'Expiration Date',
          field: 'expirationDate',
          type: 'number',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Expiration Date',
            trigger: 'input'
          },
          hidden: false
        },
        {
          label: 'Revision Date',
          field: 'revisionDate',
          type: 'number',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Revision Date',
            trigger: 'input'
          },
          hidden: true
        },
        {
          label: 'Status',
          field: 'status',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Status',
            trigger: 'input'
          },
          hidden: false
        },
        {
          label: 'Viewer Url',
          field: 'viewer_url',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Viewer Url',
            trigger: 'input'
          },
          hidden: true
        },
        {
          label: 'Last Updated',
          field: 'updatedAt',
          type: 'number',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter Last Updated',
            trigger: 'input'
          },
          hidden: true
        },
        {
          label: 'DB ID',
          field: '_id',
          sortable: true,
          hidden: true
        }
      ],
      rows: null,
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 20
      },

      // END VUE-GOOD-TABLE

      timeSearch: null,

      actualVersion: '0.097',

      isModal: false,
      duplicateFormName: '',
      duplicateFormId: '',
      isDisableBtnClone: false,

      apiUrl: this.$store.state.apiUrl,

      isModalRoles: false,
      isModalModels: false,

      roles: null,
      models: null,

      isDisableBtnSaveRoles: false,

      rolesToUpdate: [],
      newRolesToSave: [],
      modelsToUpdate: [],
      newModelsToSave: [],
      contUpdates: 0,
      contInserts: 0,

      isModalMassUpdate: false,
      passwordToAddJson: '',
      passToAddJson: 'factory',
      isInvalidPassword: false,

      bulkActionsModalLabel: '',

      isAddDataJSON: false,
      isEnableDisable: false,
      isAddInternalTag: false,
      isSpinnerMassUpdate: false,

      internalTagsForForms: [],
      tagsFormInternal: [],

      isAddSection: false,

      allSections: [],

      sectionBulkAction: '',

      labelButtonBulkAction: '',
      isAddLibrary: '',

      libraryBulkAction: '',
      isAddPracticeArea: false,
      practiceAreaForForms: [],
      practiceAreas: [],

      isAddRevisionDate: false,

      revisionDateBulkAction: '',

      isAddExpirationDate: false,
      expirationDateBulkAction: '',

      isAddVersion: false,
      versionBulkAction: '',

      formsUpdated: 0,
      formsToUpdate: 0,

      formsInvalidPath: [],

      formData: null,

      // VUE-GOOD-TABLE-MODALS

      isLoadingOModels: false,
      columnsOModels: [
        {
          label: 'Model',
          field: 'model',
        /*  filterOptions: {
            enabled: true,
            placeholder: 'Filter Model',
            trigger: 'input'
          }, */
          hidden: false
        }/* ,
        {
          label: 'Actions',
          field: 'actions',
          html: true,
          hidden: false
        } */
      ],
      rowsOModels: null,
      totalRecordsOModels: 0,
      serverParamsOModels: {
        columnFilters: {
        },
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 20
      },
      isAutocompleteModel: false,
      autocompleteModelData: null,
      autocompleteModel: '',
      listOfficialModels: [],
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight

      // END VUE-GOOD-TABLE-MODALS
    }
  },

  components: {
    ModalDialog,
    AddFormModal,
    EditFormModal,
    Notifications,
    GlobalModal,
    FSpinner,
    SearchSelect,
    VueGoodTable,
    CreateButtonModel
  },

  computed: {
    updateScreenSize () {
      return () => {
        this.screenWidth = window.innerWidth
        this.screenHeight = window.innerHeight
      }
    }
  },

  watch: {
    filterGrid (val) {
      // this.getCountForms()

      this.getFormList()
    },

    passwordToAddJson (val) {
      this.isInvalidPassword = false
    }
  },

  created () {
    // FORMS UPDATED

    this.$bus.on('setFormUpdated', () => {
      this.formsUpdated++
    })

    // FORM INVALID PATH

    this.$bus.on('setFormInvalidPath', (form) => {
      this.formsInvalidPath.push(form)
    })

    // CLOSE BULK ACTION MODAL

    this.$bus.on('closeBulkActionsModal', () => {
      this.closeBulkActionsModal()
    })

    // GET FORM LIST
    this.$bus.on('getFormList', () => {
      this.isLoading = true
      this.getFormList()
    })

    // GET FORM LIST
    this.$bus.on('closeCreateButtonModels', () => {
      this.closeCreateButtonModels()
    })

    window.addEventListener('resize', this.updateScreenSize)
  },

  mounted () {
    this.$store.commit('setAutofillId', null)
    this.$store.commit('setAutofillDetails', null)
    this.$store.commit('setOfficialModels', null)
    this.$store.commit('setCurrentPage', 1)

    let that = this

    this.getModels()
    this.getData()

    this.$on('closeModal', function () {
      that.addFormModalVisible = false
      that.editFormModalVisible = false
    })

    this.$bus.on('confirmFormDelete', this.deleteForm)
  },

  methods: {
    deleteForm () {
      const apiUrl = this.$store.state.apiUrl
      this.axios.get(apiUrl + 'form/' + this.deleteId + '/delete').then(response => {
        if (response.data.success) {
          this.$store.commit('deleteForm', this.deleteId)
          window.Sweetalert2.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'The form was deleted successfully.',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 1200
          })

          this.isLoading = true
          this.getFormList()
        } else {
          window.Sweetalert2.fire({
            toast: true,
            position: 'top-end',
            icon: 'warning',
            title: 'There was an error deleting the form.',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 1200
          })
        }
      })
    },

    confirmDelete (deleteId) {
      window.Sweetalert2.fire({
        title: 'Delete Form?',
        text: 'You are about to delete this form and all of its templates. Do you want to continue?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteId = deleteId
          this.deleteForm()
        }
      })
    },

    showEditFormModal (formId) {
      this.editFormModalVisible = true
      this.$refs.editModal.$emit('setId', formId)
      this.$bus.emit('setPracticeAreaSections')
    },

    getModels () {
      const apiUrl = this.$store.state.apiUrl
      this.axios.get(apiUrl + 'model/list').then(response => {
        this.$store.commit('setModels', response.data)
      })
    },

    getData () {
      const apiUrl = this.$store.state.apiUrl

      // this.getCountForms()

      this.getFormList()

      this.axios.get(apiUrl + 'role/list').then(response => {
        this.$store.commit('setFormRoles', response.data)
      })

      this.axios.get(apiUrl + 'practice-area').then(response => {
        this.$store.commit('setPracticeAreas', response.data)
      })
    },

    showAddFormModal () {
      this.addFormModalVisible = true
    },

    openModalDuplicateForm (formId, formName) {
      this.isModal = true
      this.isDisableBtnClone = false

      this.duplicateFormId = formId
      this.duplicateFormName = formName + '_copy'
    },

    cloneTemplate () {
      this.isDisableBtnClone = true

      this.axios.get(this.$store.state.apiUrl + 'form/' + this.duplicateFormId).then(responseForm => {
        let formData = responseForm.data[0]

        formData.name = this.duplicateFormName

        formData.status = 'Disabled'

        formData.enableForQuestionnaire = false

        delete formData._id

        this.createNewForm(formData)
      })
    },

    createNewForm (formData) {
      this.axios.post(this.$store.state.apiUrl + 'form/add', formData).then(responseAddForm => {
        this.axios.get(this.$store.state.apiUrl + 'template/list/' + this.duplicateFormId).then(response => {
          let templates = response.data

          this.createNewTemplates({
            templates,
            newFormId: responseAddForm.data.formId
          })

          this.axios.get(this.$store.state.apiUrl + 'form/list').then(response => {
            this.$store.commit('setForms', response.data)
          })
        })
      })
    },

    createNewTemplates (payload) {
      payload.templates.forEach(newTemplate => {
        newTemplate.formId = payload.newFormId

        let oldTemplateId = newTemplate._id

        delete newTemplate._id

        this.$store.dispatch('uploadTemplate', newTemplate).then(responseTemplate => {
          if (responseTemplate.data.success) {
            this.$bus.emit('addNotification', {
              title: 'Template Added',
              body: 'The global and default template were added successfully.',
              type: 'success'
            })

            if (newTemplate.name === 'default') {
              this.createNewAutofill({
                newFormId: payload.newFormId,
                newTemplateId: responseTemplate.data.id
              })
            }

            this.axios.get(this.$store.state.apiUrl + 'questionnaire/list/' + oldTemplateId).then(response => {
              let questionnaire = response.data[0]

              if (questionnaire === undefined) return

              questionnaire.templateId = responseTemplate.data.id

              delete questionnaire._id

              this.createNewQuestionnaire({
                questionnaire,
                newTemplateId: responseTemplate.data.id
              })
            })
          } else {
            this.$bus.emit('addNotification', {
              title: 'Template Error',
              body: 'There was an error adding the new global template to this form. Please review the data and try again',
              type: 'error'
            })
          }

          this.isModal = false
        })
      })
    },

    createNewAutofill (payload) {
      // CREATE NEW AUTOFILL

      const autofill = {
        formId: payload.newFormId,
        templateId: payload.newTemplateId,
        name: 'global',
        caseTypeId: 0,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      this.$store.dispatch('addAutofill', autofill).then(response => {
        this.createNewAutofillDetails({
          newAutofillId: response.data.autofillId,
          newTemplateId: payload.newTemplateId
        })
      })
    },

    createNewAutofillDetails (payload) {
      this.$store.dispatch('getAutofill', this.duplicateFormId).then(responseAutofill => {
        let oldAutofillId = responseAutofill.data[0]._id

        this.axios.get(this.$store.state.apiUrl + 'autofillDetails/autofill-id/?autofillId=' + oldAutofillId).then(responseAutofill => {
          let newAutofillDetails = JSON.parse(JSON.stringify(responseAutofill.data))

          newAutofillDetails.forEach((autofillDetail, indexAutofillDetail) => {
            autofillDetail.autofillId = payload.newAutofillId

            autofillDetail.templateId = payload.newTemplateId

            delete autofillDetail._id

            autofillDetail.createdAt = new Date()
            autofillDetail.updatedAt = new Date()

            newAutofillDetails[indexAutofillDetail] = autofillDetail
          })

          this.$store.dispatch('addAutofillDetail', newAutofillDetails).then(responseAddAutofillDetail => {
            if (responseAddAutofillDetail.data.success === true) {
              window.vueBus.emit('addNotification', {
                title: 'Autofill details',
                body: 'Autofill details added successfully.',
                type: 'success'
              })
            } else {
              window.vueBus.emit('addNotification', {
                title: 'Autofill details',
                body: 'Ocurred an error, try one more time.',
                type: 'error'
              })
            }
          })
        })
      })
    },

    createNewQuestionnaire (payload) {
      this.$store.dispatch('uploadDefaultQuestionnaire', payload.newTemplateId).then(responseQuestionnaire => {
        if (responseQuestionnaire.data.success) {
          this.$bus.emit('addNotification', {
            title: 'Questionnaire Added',
            body: 'Succesfully adding the questionnaire to this form.',
            type: 'success'
          })

          this.updateNewQuestionnaire({
            newQuestionnaireId: responseQuestionnaire.data.id,
            newQuestionnaire: payload.questionnaire
          })
        } else {
          this.$bus.emit('addNotification', {
            title: 'Questionnaire Error',
            body: 'There was an error adding the default questionnaire to this form. Please review the data and try again',
            type: 'error'
          })
        }
      })
    },

    updateNewQuestionnaire (payload) {
      const requestData = {
        questionnaireId: payload.newQuestionnaireId,
        newData: payload.newQuestionnaire
      }

      this.axios.post(this.$store.state.apiUrl + 'questionnaire/update', requestData).then(response => {
        this.$bus.emit('addNotification', {
          title: 'Questionnaire Updated',
          body: 'Succesfully updated the new questionnaire to this form.',
          type: 'success'
        })
      })
    },

    onBtnExportDataAsCsv () {
      const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: 'My Awesome CSV',
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
      }

      const csvExporter = new ExportToCsv(options)

      let dataCsv = JSON.parse(JSON.stringify(this.rows))

      // REMOVE COLUMNS
      dataCsv.forEach(form => {
        delete form.properties
        delete form.deletedAt
        delete form._id
        delete form.data
        delete form.__v
      })

      csvExporter.generateCsv(dataCsv)
    },

    showRolesModal () {
      this.isModalRoles = true

      this.roles = JSON.parse(JSON.stringify(this.$store.state.formRoles))
    },

    showModelsModal () {
      this.isModalModels = true

      // this.models = JSON.parse(JSON.stringify(this.$store.state.models))
      this.getOfficialModels()
    },

    addNewRol () {
      this.roles.push({
        id: Math.random().toString(36).substring(7),
        name: '',
        type: '',
        isNew: true
      })

      setTimeout(() => {
        document.getElementById((this.roles.length - 1)).scrollIntoView({block: 'end', behavior: 'smooth'})
        document.getElementById('inputName' + (this.roles.length - 1)).focus()
      }, 500)
    },

    addNewModel () {
      this.models.push({
        id: Math.random().toString(36).substring(7),
        category: '',
        desc: '',
        field: '',
        fieldType: '',
        label: '',
        prefix: '',
        properties: '',
        route: '',
        subcategory: '',
        type: '',
        isNew: true
      })

      setTimeout(() => {
        document.getElementById((this.models.length - 1)).scrollIntoView({block: 'end', behavior: 'smooth'})
        document.getElementById('inputName' + (this.models.length - 1)).focus()
      }, 500)
    },

    prevToSaveRole (indexRole) {
      let currentRole = this.roles[indexRole]

      if (currentRole.isNew && currentRole.name !== '' && currentRole.type !== '') {
        if (this.newRolesToSave.map(a => a.id).indexOf(currentRole.id) === -1) {
          this.newRolesToSave.push(currentRole)
        } else {
          this.newRolesToSave[this.newRolesToSave.map(a => a.id).indexOf(currentRole.id)] = currentRole
        }
      } else {
        if (this.rolesToUpdate.map(a => a._id).indexOf(currentRole._id) === -1) {
          this.rolesToUpdate.push(currentRole)
        } else {
          this.rolesToUpdate[this.rolesToUpdate.map(a => a._id).indexOf(currentRole._id)] = currentRole
        }
      }
    },

    prevToSaveModel (indexModel) {
      let currentModel = this.models[indexModel]

      if (currentModel.isNew && currentModel.field !== '' && currentModel.type !== '') {
        if (this.newModelsToSave.map(a => a.id).indexOf(currentModel.id) === -1) {
          this.newModelsToSave.push(currentModel)
        } else {
          this.newModelsToSave[this.newModelsToSave.map(a => a.id).indexOf(currentModel.id)] = currentModel
        }
      } else {
        if (this.modelsToUpdate.map(a => a._id).indexOf(currentModel._id) === -1) {
          this.modelsToUpdate.push(currentModel)
        } else {
          this.modelsToUpdate[this.modelsToUpdate.map(a => a._id).indexOf(currentModel._id)] = currentModel
        }
      }
    },

    saveRoles () {
      this.roles.forEach((role, indexRole) => {
        if (role.isNew && (role.name === '' || role.type === '')) this.roles.splice(indexRole, 1)
      })

      this.addRoles()
      this.updateRoles()
    },

    saveModels () {
      this.models.forEach((model, indexModel) => {
        if (model.isNew && (model.field === '' || model.type === '')) this.models.splice(indexModel, 1)
      })

      this.addModels()
      this.updateModels()
    },

    addRoles () {
      this.contInserts = 0

      this.newRolesToSave.forEach(newRole => {
        this.$store.dispatch('addRole', newRole).then(response => {
          this.contInserts++

          if ((this.rolesToUpdate.length + this.newRolesToSave.length) === (this.contUpdates + this.contInserts)) {
            this.closeRolesModal()
          }
        })
      })
    },

    updateRoles () {
      this.contUpdates = 0

      this.rolesToUpdate.forEach(role => {
        let roleId = role._id
        let newData = role

        this.$store.dispatch('updateRole', {
          roleId,
          newData
        }).then(response => {
          this.contUpdates++

          if ((this.rolesToUpdate.length + this.newRolesToSave.length) === (this.contUpdates + this.contInserts)) {
            this.closeRolesModal()
          }
        })
      })
    },

    addModels () {
      this.contInserts = 0

      this.newModelsToSave.forEach(newModel => {
        this.$store.dispatch('addModel', newModel).then(response => {
          this.contInserts++

          if ((this.modelsToUpdate.length + this.newModelsToSave.length) === (this.contUpdates + this.contInserts)) {
            this.closeModelsModal()
          }
        })
      })
    },

    updateModels () {
      this.contUpdates = 0

      this.modelsToUpdate.forEach(model => {
        let modelId = model._id
        let newData = model

        this.$store.dispatch('updateModel', {
          modelId,
          newData
        }).then(response => {
          this.contUpdates++

          if ((this.modelsToUpdate.length + this.newModelsToSave.length) === (this.contUpdates + this.contInserts)) {
            this.closeModelsModal()
          }
        })
      })
    },

    closeRolesModal () {
      this.$store.commit('setFormRoles', this.roles)
      this.isModalRoles = false
      this.newRolesToSave = []
      this.rolesToUpdate = []
    },

    closeModelsModal () {
      this.$store.commit('setModels', this.models)
      this.isModalModels = false
      this.newModelsToSave = []
      this.modelsToUpdate = []
    },

    addJsonToSelectedForms () {
      if (btoa(this.passToAddJson) !== this.passwordToAddJson) {
        this.isInvalidPassword = true

        return
      }

      this.isSpinnerMassUpdate = true

      let elFilters = document.querySelectorAll('.ag-floating-filter-input')

      this.$store.commit('setBlankFilters')

      let allFilters = []

      elFilters.forEach(filter => {
        allFilters.push(filter.value)
      })

      this.$store.commit('setAllFilters', {
        filters: allFilters
      })

      this.formsToUpdate = this.$refs['forms-table'].selectedRows.length

      this.$bus.emit('updateTemplatesMassive', {
        formsCheckedList: this.$refs['forms-table'].selectedRows
      })
    },

    openModalAddJSONGitHub () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddDataJSON = true
      this.bulkActionsModalLabel = 'Load JSON from GitHub Repository'
    },

    openModalEnbaleDisable () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isEnableDisable = true
      this.bulkActionsModalLabel = 'Enable / Disable'
    },

    closeBulkActionsModal () {
      this.isModalMassUpdate = false
      this.passwordToAddJson = ''
      this.isAddDataJSON = false
      this.isEnableDisable = false
      this.isAddInternalTag = false
      this.isAddSection = false
      this.isAddLibrary = false
      this.isAddPracticeArea = false
      this.isAddRevisionDate = false
      this.isAddExpirationDate = false
      this.isAddVersion = false

      this.isSpinnerMassUpdate = false

      this.bulkActionsModalLabel = ''
      this.labelButtonBulkAction = ''

      this.internalTagsForForms = []
      this.sectionBulkAction = ''
      this.libraryBulkAction = ''
      this.practiceAreaForForms = []
      this.revisionDateBulkAction = ''
      this.expirationDateBulkAction = ''
      this.versionBulkAction = ''

      this.formsUpdated = 0
      this.formsToUpdate = 0
      this.formsInvalidPath = []

      this.formsCheckedList = []
    },

    enableForms () {
      this.setMassUpdate({
        status: 'Enabled'
      })
    },

    disableForms () {
      this.setMassUpdate({
        status: 'Disabled'
      })
    },

    timeout (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    async setMassUpdate (payload) {
      this.formsToUpdate = this.$refs['forms-table'].selectedRows.length
      this.isSpinnerMassUpdate = true
      this.isLoading = true

      for (let contForm = 0; contForm < this.$refs['forms-table'].selectedRows.length; contForm++) {
        let newData = JSON.parse(
          JSON.stringify(
            this.$store.state.forms.filter(
              form => form._id === this.$refs['forms-table'].selectedRows[contForm]._id
            )[0]
          )
        )

        if (this.isEnableDisable) newData.status = payload.status
        else if (this.isAddInternalTag === true) {
          payload.tags.forEach((tag, tagIndex) => {
            if (newData.internalTag.indexOf(tag) === -1) newData.internalTag.push(tag)
          })
        } else if (this.isAddSection === true) newData.practiceAreaSection = payload.section
        else if (this.isAddLibrary === true) newData.practiceArea = payload.library
        else if (this.isAddPracticeArea === true) {
          payload.practiceAreas.forEach((tag, tagIndex) => {
            if (newData.practiceAreaTag.indexOf(tag) === -1) newData.practiceAreaTag.push(tag)
          })
        } else if (this.isAddRevisionDate === true) newData.revisionDate = payload.revisionDate
        else if (this.isAddExpirationDate === true) newData.expirationDate = payload.expirationDate
        else if (this.isAddVersion === true) newData.version = payload.version

        let formData = {
          formId: newData._id,
          newData: newData
        }

        this.formData = formData

        await this.updateForm({
          formData
        })

        this.$bus.emit('setFormUpdated')

        await this.timeout(1)
      }

      this.getFormList()

      // CLOSE MODAL BULK ACTIONS & PROPS

      this.isModalMassUpdate = false
      this.isSpinnerMassUpdate = false
      this.isEnableDisable = false
      this.isAddInternalTag = false
      this.isAddSection = false
      this.isAddLibrary = false
      this.isAddPracticeArea = false
      this.isAddRevisionDate = false
      this.isAddExpirationDate = false
      this.isAddVersion = false
    },

    updateForm (payload) {
      this.$store.dispatch('updateForm', {
        formData: payload.formData
      }).then(response => {
        if (response.data.success) {
          this.$bus.emit('addNotification', {
            title: 'Form Updated',
            body: 'The form was updated successfully.',
            type: 'success'
          })
        } else {
          this.$bus.emit('addNotification', {
            title: 'Update Error',
            body: 'There was an error updating this form. Please check the data and try again.',
            type: 'error'
          })
        }
      })
    },

    openModalAddInternalTag () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddInternalTag = true

      if (this.internalTagsForForms.length === 0) {
        this.$store.dispatch('getFormTags', {
          tagType: 'internal'
        }).then(response => {
          if (response.data !== undefined && response.data !== null) this.tagsFormInternal = response.data
        })
      }

      this.bulkActionsModalLabel = 'Internal Tags'
      this.labelButtonBulkAction = 'Upload'
    },

    addInternalTagMassUpdate () {
      this.setMassUpdate({
        tags: this.internalTagsForForms
      })
    },

    openModalAddSection () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddSection = true

      if (this.allSections.length === 0) {
        this.$store.state.practiceAreas.map(a => a.sections).forEach(groupSection => {
          this.allSections = this.allSections.concat(groupSection)
        })
      }

      this.bulkActionsModalLabel = 'Sections'
      this.labelButtonBulkAction = 'Upload'
    },

    addSectionsMassUpdate () {
      this.setMassUpdate({
        section: this.sectionBulkAction
      })
    },

    setBulkAction () {
      if (this.isAddInternalTag === true) this.addInternalTagMassUpdate()
      else if (this.isAddSection === true) this.addSectionsMassUpdate()
      else if (this.isAddLibrary === true) this.addLibraryMassUpdate()
      else if (this.isAddPracticeArea === true) this.addPracticeAreaMassUpdate()
      else if (this.isAddRevisionDate === true) this.addRevisionDateMassUpdate()
      else if (this.isAddExpirationDate === true) this.addExpirationDateMassUpdate()
      else if (this.isAddVersion === true) this.addVersionMassUpdate()
    },

    openModalAddLibrary () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddLibrary = true

      this.bulkActionsModalLabel = 'Library'
      this.labelButtonBulkAction = 'Upload'
    },

    addLibraryMassUpdate () {
      this.setMassUpdate({
        library: this.libraryBulkAction.name
      })
    },

    openModalAddPracticeArea () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddPracticeArea = true

      if (this.practiceAreas.length === 0) {
        this.$store.dispatch('getFormTags', {
          tagType: 'practiceArea'
        }).then(response => {
          if (response.data !== undefined && response.data !== null) this.practiceAreas = response.data
        })
      }

      this.bulkActionsModalLabel = 'Practice Area'
      this.labelButtonBulkAction = 'Upload'
    },

    addPracticeAreaMassUpdate () {
      this.setMassUpdate({
        practiceAreas: this.practiceAreaForForms
      })
    },

    openModalAddRevisionDate () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddRevisionDate = true

      this.bulkActionsModalLabel = 'Revision Date'
      this.labelButtonBulkAction = 'Upload'
    },

    addRevisionDateMassUpdate () {
      this.setMassUpdate({
        revisionDate: this.revisionDateBulkAction
      })
    },

    openModalAddExpirationDate () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddExpirationDate = true

      this.bulkActionsModalLabel = 'Expiration Date'
      this.labelButtonBulkAction = 'Upload'
    },

    addExpirationDateMassUpdate () {
      this.setMassUpdate({
        expirationDate: this.expirationDateBulkAction
      })
    },

    openModalAddVersion () {
      if (!this.$refs['forms-table'].selectedRows.length || this.$refs['forms-table'].selectedRows.length === 0) return

      this.isModalMassUpdate = true
      this.isAddVersion = true

      this.bulkActionsModalLabel = 'Version'
      this.labelButtonBulkAction = 'Upload'
    },

    addVersionMassUpdate () {
      this.setMassUpdate({
        version: this.versionBulkAction
      })
    },

    // METHODS REMOTE VUE-GOOD-TABLE

    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onSearch (params) {
      window.clearTimeout(this.timeSearch)

      this.timeSearch = setTimeout(() => {
        this.isLoading = true
        this.updateParams({
          page: 1,
          searchTerm: {
            value: params.searchTerm,
            fields: this.columns.map(column => column.field)
          }
        })
        this.getFormList()
      }, 800)
    },

    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.getFormList()
    },

    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.getFormList()
    },

    onSortChange (params) {
      this.updateParams({
        sort: params[0]
      })
      this.getFormList()
    },

    onColumnFilter (params) {
      params.page = 1
      this.updateParams(params)
      this.getFormList()
    },

    getFormList () {
      this.$store.dispatch('getFormList', this.serverParams).then(response => {
        this.$store.commit('setForms', response.list)

        this.rows = JSON.parse(JSON.stringify(response.list))

        this.rows.forEach(form => {
          // PRACTICE AREA => PRACTICE AREA TAG
          form.practiceAreaTag = String(form.practiceAreaTag)

          // INTERNAL TAG
          form.internalTag = String(form.internalTag)

          // FORMAT EXPIRATION DATE
          form.expirationDate = this.moment(form.expirationDate).format('YYYY-MM-DD') !== 'Invalid date'
            ? this.moment(form.expirationDate).format('YYYY-MM-DD')
            : ''

          // FORMAT REVISION DATE
          form.revisionDate = this.moment(form.revisionDate).format('YYYY-MM-DD') !== 'Invalid date'
            ? this.moment(form.revisionDate).format('YYYY-MM-DD')
            : ''

          // FORMAT LAST UPDATED
          form.updatedAt = this.moment(form.updatedAt).format('YYYY-MM-DD') !== 'Invalid date'
            ? this.moment(form.updatedAt).format('YYYY-MM-DD')
            : ''
        })

        this.rows = Object.assign([], this.rows, this.rows)

        if (this.serverParams.searchTerm !== undefined) {
          this.rows = this.serverParams.searchTerm.value !== '' ? this.rows.sort(this.compararObjetos) : this.rows
        }

        this.totalRecords = response.totalRecords
      })
    },

    compararObjetos (a, b) {
      if (a.status < b.status) {
        return -1
      }
      if (a.status > b.status) {
        return 1
      }

      if (a.version < b.version) {
        return -1
      }
      if (a.version > b.version) {
        return 1
      }

      return 0
    },

    onCellClick (params) {
      if (params.column.field !== 'actions' && params.column.field !== '_id') {
        this.$bus.emit('openFormApp', {
          formId: params.row._id
        })
        return
      }
      if (params.column.field === '_id') {
        this.$copyText(params.row._id).then(() => {
          window.Sweetalert2.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Copied!',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 800
          })
        })
      }
    },

    getOfficialModels () {
      this.rowsOModels = Object.assign([], this.rowsOModels, this.rowsOModels)

      this.$store.dispatch('getOfficialModelsList', this.serverParamsOModels).then(response => {
        this.rowsOModels = JSON.parse(JSON.stringify(response.list))

        this.rowsOModels = Object.assign([], this.rowsOModels, this.rowsOModels)

        if (this.serverParamsOModels.searchTerm !== undefined) {
          this.rowsOModels = this.serverParamsOModels.searchTerm.value !== '' ? this.rowsOModels.sort(this.compararObjetosOModels) : this.rowsOModels
        }

        this.totalRecordsOModels = response.totalRecords
        if (this.totalRecordsOModels === 0) {
          this.isAutocompleteModel = true
          this.autocompleteModelData = {}
          this.autocompleteModelData.top = this.screenHeight * 0.27
          this.autocompleteModelData.left = this.screenWidth * 0.25
          this.autocompleteModel = this.serverParamsOModels.searchTerm.value.toString()
        } else {
          this.isAutocompleteModel = false
        }
      })
    },

    updateParamsOfficialModels (newProps) {
      this.serverParamsOModels = Object.assign({}, this.serverParamsOModels, newProps)
    },

    onSearchOModels (params) {
      window.clearTimeout(this.timeSearch)

      this.timeSearch = setTimeout(() => {
        this.isLoading = true
        this.updateParamsOfficialModels({
          page: 1,
          searchTerm: {
            value: params.searchTerm,
            fields: this.columnsOModels.map(column => column.field)
          }
        })
        this.getOfficialModels()
      }, 800)
    },

    onPageChangeOModels (params) {
      this.updateParamsOfficialModels({page: params.currentPage})
      this.getOfficialModels()
    },

    onPerPageChangeOModels (params) {
      this.updateParamsOfficialModels({perPage: params.currentPerPage})
      this.getOfficialModels()
    },

    onSortChangeOModels (params) {
      this.updateParamsOfficialModels({
        sort: params[0]
      })
      this.getOfficialModels()
    },

    onColumnFilterOModels (params) {
      params.page = 1
      this.updateParamsOfficialModels(params)
      this.getOfficialModels()
    },

    compararObjetosOModels (a, b) {
      if (a.model < b.model) {
        return -1
      }
      if (a.model > b.model) {
        return 1
      }
      return 0
    },

    onCellClickOModels (params) {
      let jona = params.row.model
      alert(jona)
    },

    closeModalModels () {
      this.isModalModels = false
      this.serverParamsOModels.searchTerm.value = ''
      setTimeout(() => {
        this.isAutocompleteModel = false
      }, 500)
      this.getOfficialModels()
    },

    closeCreateButtonModels () {
      this.serverParamsOModels.searchTerm.value = ''
      setTimeout(() => {
        this.isAutocompleteModel = false
      }, 500)
      this.getOfficialModels()
    },

    logOut () {
      window.sweetAlert({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: ['Cancel', 'Yes, log out']
      }).then(res => {
        if (res === true) {
          localStorage.removeItem('accesToken')
          this.$router.push('/login')
        }
      })
    }
  },

  beforeDestroy () {
    this.$bus.$off('openForm')
    this.$bus.$off('openModalDuplicateForm')
    this.$bus.$off('confirmDelete')
    this.$bus.$off('showEditFormModal')
    this.$bus.$off('setFormUpdated')
    this.$bus.$off('setFormInvalidPath')
    this.$bus.$off('reloadFormsList')
    this.$bus.$off('filterGrid')
    this.$bus.$off('closeBulkActionsModal')
    this.$bus.$off('setFilters')
    this.$bus.$off('getFormList')
    window.removeEventListener('resize', this.updateScreenSize)
    this.$bus.off('hideAutocompleteModel')
  }
}
</script>

<style lang="scss" scoped>

  .heightGrid{
    height: 95%;
    width: 100%;
  }

  #formGrid{
    height: 90%;
  }

  @media (min-height: 850px) {
    .heightGrid{
      height: 97%;
    }

    #formGrid{
      height: 92%;
    }
  }

  @media (min-width: 992px){
    .navMovil{
      padding-top: 0rem !important;
      padding-bottom: 0rem !important;
    }
  }

  // @media (max-width: 767px){
  //   .navMovil{
  //     padding: .5rem 1rem !important;
  //   }
  // }

  #formGrid {
    padding-left: 5px;
    padding-right: 5px;
    position: relative;
    text-align: center;
    user-select: none;
    height: 92%;

    button {
      position: absolute;
      top: 30px;
      right: 1.6%;
      z-index: 10;
    }
  }

  tbody {
    display:block;
    height:500px;
    overflow:auto;
  }

  thead, tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
  }

  .fa-edit, .fa-trash, .fa-clone {
    cursor: pointer;
  }

  .status-warning {
    background-color: sandybrown !important;
  }

  .status-breach {
    background-color: rgb(255, 235, 235) !important;
  }

  i {
    cursor: pointer;
  }

  .fontAwesome {
    font-family: Helvetica, 'FontAwesome', sans-serif;
  }

  .navbar {
    margin-bottom: 0px !important;
  }

  .trModels {
    text-align:center;
  }

  .tdModelNo {
    text-align:center;
    width:45px;
  }

  .theadModels {
    width:98.577% !important;
  }

  @import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>



// WEBPACK FOOTER //
// src/views/ListView.vue